import { Col, Container, Row } from '@bootstrap-styled/v4';
import React from 'react';
import { baseURL } from 'shared-components/theme/helpers';
import styled from 'styled-components';
import SectionTitle from './section-tag';
import IntroductionTitle from './introduction-title';
import Pills from './pills';
import colors from 'shared-components/theme/colors';
import IntroductionDesc from './introduction-desc';
import { gilroyBold, gilroyMedium } from 'shared-components/theme/fonts';
import Media from 'shared-components/theme/medias';
import CountUp from 'react-countup';
import ScrollAnimation from 'react-animate-on-scroll';
const Tech = () => {
    const leftPills = [
        'Beyond Voice',
        'AI',
        'CLoud',
        'Cybersecurity',
        'CRM support',
    ];
    const rightPills = [
        'Top freelance hub',
        '$900 million in 2025',
        'Government-backed infrastructure',
    ];
    return (
        <Wrap id="tech">
            <LeftCol>
                <Container>
                    <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                        <SectionTitle tag={'THE TECH'} textColor={'#01411C'} />
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={100}>
                        <IntroductionTitle
                            title={'Cutting-edge tech. Customer Ready'}
                            textColor={'#042914'}
                        />
                    </ScrollAnimation>
                    <PillContainer>
                        {leftPills.map((pill, i) => (
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                key={i}
                                delay={(i + 1) * 50}>
                                <Pills
                                    text={pill}
                                    color={colors.geoGreen[90]}
                                    borderColor={colors.geoGreen[90]}
                                />
                            </ScrollAnimation>
                        ))}
                    </PillContainer>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={200}>
                        <Row className="info_row">
                            <Col lg="4">
                                <TechCount>
                                    <CountUp
                                        start={0}
                                        end={35}
                                        suffix="K"
                                        enableScrollSpy={true}
                                        scrollSpyOnce={true}
                                    />
                                    <span style={{ color: colors.white[100] }}>
                                        +
                                    </span>
                                </TechCount>
                            </Col>
                            <Col lg="8">
                                <IntroductionDesc
                                    desc={
                                        'IT grads means deep technical capability-ready to scale modern CX operations.'
                                    }
                                    textColor={colors.geoGreen[100]}
                                />
                            </Col>
                        </Row>
                    </ScrollAnimation>
                </Container>
            </LeftCol>
            <RightCol>
                <Container>
                    <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                        <SectionTitle
                            tag={'THE TECH LANDSCAPE'}
                            textColor={'#fff'}
                        />
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={100}>
                        <IntroductionTitle
                            title={'Built on a Booming Tech Landscape'}
                            textColor={'#fff'}
                        />
                    </ScrollAnimation>
                    <PillContainer>
                        {rightPills.map((pill, i) => (
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                animateOnce={true}
                                delay={(i + 1) * 50}
                                key={i}>
                                <Pills
                                    text={pill}
                                    color={colors.white[100]}
                                    borderColor={colors.white[100]}
                                />
                            </ScrollAnimation>
                        ))}
                    </PillContainer>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        animateOnce={true}
                        delay={200}>
                        <Row className="info_row">
                            <Col lg="4">
                                <TechCount textColor={colors.white[100]}>
                                    <span
                                        style={{ color: colors.geoGreen[50] }}>
                                        $
                                    </span>
                                    <CountUp
                                        start={0}
                                        end={3.5}
                                        decimals="1"
                                        suffix="B"
                                        enableScrollSpy={true}
                                        scrollSpyOnce={true}
                                    />
                                </TechCount>
                            </Col>
                            <Col lg="8">
                                <IntroductionDesc
                                    desc={
                                        'The IT services market in PK is projected to reach $3.50 billion by 2029 with a 7.31% annual growth rate.'
                                    }
                                    textColor={colors.white[100]}
                                />
                            </Col>
                        </Row>
                    </ScrollAnimation>
                </Container>
            </RightCol>
        </Wrap>
    );
};

export default Tech;

const Wrap = styled.div`
    display: flex;
    position: relative;
    z-index: 2;
    scroll-margin-top: 100px;
    .info_row {
        margin-top: 30px;
        ${Media('large')} {
            margin-top: 1.785vw;
        }
    }

    ${Media('tabletlandscape')} {
        flex-direction: column;
    }
`;

const LeftCol = styled.div`
    width: 50%;
    background: #3bf78a;

    .container {
        padding-right: 120px !important;
        padding-top: 130px !important;
        padding-bottom: 130px !important;
        ${Media('large')} {
            padding-right: 7.139vw !important;
            padding-top: 7.733vw !important;
            padding-bottom: 7.733vw !important;
        }
        ${Media('tabletlandscape')} {
            padding-right: unset !important;
            padding-top: 60px !important;
            padding-bottom: 60px !important;
            padding-left: unset !important;
        }
        ${Media('mobile')} {
            padding-right: 20px !important;
            padding-left: 20px !important;
        }
    }

    ${Media('tabletlandscape')} {
        width: 100%;
    }
`;
const RightCol = styled.div`
    width: 50%;
    background: url(${baseURL}assets/images/geos/pakistan/landscape_bg.jpg)
        no-repeat center/cover;

    .container {
        padding-left: 90px !important;
        padding-top: 130px !important;
        padding-bottom: 130px !important;

        ${Media('large')} {
            padding-left: 5.354vw !important;
            padding-top: 7.733vw !important;
            padding-bottom: 7.733vw !important;
        }

        ${Media('tabletlandscape')} {
            padding-left: unset !important;
            padding-top: 60px !important;
            padding-bottom: 60px !important;
        }
        ${Media('mobile')} {
            padding-right: 20px !important;
            padding-left: 20px !important;
        }
    }
    ${Media('tabletlandscape')} {
        width: 100%;
    }
`;

const PillContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
`;

const TechCount = styled.h4`
    font-size: 48px;
    font-family: ${gilroyMedium};
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 30px 0 0;
    color: ${(props) =>
        props.textColor ? props.textColor : colors.geoGreen[100]};

    ${Media('large')} {
        font-size: 2.6vw;
    }
    ${Media('laptops')} {
        font-size: 34px;
    }
    ${Media('tabletlandscape')} {
        font-size: 48px;
    }
    // ${Media('mobile')} {
    //     font-size: 22px;
    // }
`;
